function TimeStampGenerator() {
    return Date.now();

}
export default TimeStampGenerator;
